import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Layout from "@/components/Layout";
import ScrollToTop from "@/components/ScrollToTop";
import Home from "@/pages/Home";
import Shop from "@/pages/Shop";
import Legacy from "@/pages/Legacy";
import About from "@/pages/About";
import Reimagined from "@/pages/Reimagined";
import MarketQueens from "@/pages/MarketQueens";
import Impact from "@/pages/Impact";
import FactOrFaytex from "@/pages/FactOrFaytex";
import B2B from "@/pages/B2B";
import Admin from "@/pages/Admin";
import AdminLogin from "@/pages/AdminLogin";
import AdminInquiries from "@/pages/AdminInquiries";
import ProductDetail from "@/pages/ProductDetail";
import PaymentCallback from "@/pages/PaymentCallback";
import Blog from "@/pages/Blog";
import BlogPost from "@/pages/BlogPost";
import ProtectedRoute from "@/components/ProtectedRoute";
import { AuthProvider } from "@/lib/AuthContext";
import { CartProvider } from "@/lib/CartContext";
import Cart from "@/pages/Cart";
import { Toaster } from "sonner";

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <CartProvider>
          <BrowserRouter>
            <ScrollToTop />
            <Routes>
              <Route element={<Layout />}>
              <Route path="/" element={<Home />} />
              <Route path="/shop" element={<Shop />} />
              <Route path="/shop/:id" element={<ProductDetail />} />
              <Route path="/legacy" element={<Legacy />} />
              <Route path="/about" element={<About />} />
              <Route path="/reimagined" element={<Reimagined />} />
              <Route path="/market-queens" element={<MarketQueens />} />
              <Route path="/impact" element={<Impact />} />
              <Route path="/blog" element={<Blog />} />
              <Route path="/blog/:slug" element={<BlogPost />} />
              <Route path="/fact-or-faytex" element={<FactOrFaytex />} />
              <Route path="/b2b" element={<B2B />} />
              <Route path="/payments/callback" element={<PaymentCallback />} />
              <Route path="/cart" element={<Cart />} />
              <Route path="/admin/login" element={<AdminLogin />} />
              <Route
                path="/admin"
                element={
                  <ProtectedRoute>
                    <Admin />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/admin/inquiries"
                element={
                  <ProtectedRoute>
                    <AdminInquiries />
                  </ProtectedRoute>
                }
              />
            </Route>
          </Routes>
        </BrowserRouter>
        </CartProvider>
      </AuthProvider>
      <Toaster position="top-center" richColors />
    </div>
  );
}

export default App;
